export default __webpack_public_path__ + "static/media/clubBg2.f8ffc085.png";